import { useTranslation } from "react-i18next";
import { ORDER_TYPE } from "../../constants";

export default function ({ type }) {
    const { t } = useTranslation();

    const TagType = ({ type }) => {
        switch (type) {
            case ORDER_TYPE.market:
                return (
                    <div className="flex items-center h-[16px] px-[4px] mr-[2px] rounded-[4px] bg-bg_1">
                        <span className="text-direction1 font-Regular text-text_2">
                            {t("market_text")}
                        </span>
                    </div>
                );
            case ORDER_TYPE.limit:
                return (
                    <div className="flex items-center h-[16px] px-[4px] mr-[2px] rounded-[4px] bg-bg_1">
                        <span className="text-direction1 font-Regular text-text_2">
                            {t("limit")}
                        </span>
                    </div>
                );
            default:
                return null;
        }
    };

    return <TagType type={type} />;
}
